import React from "react";
import styles from "./_css/footer.module.css";
import { Logo } from "_common/icons/Logo";
import { FooterLinkList } from "main/footer/FooterLinkList";
import { LINKS } from "main/footer/links";
import { FooterSubscribe } from "main/footer/FooterSubscribe";
import { PopularExplore } from "popular/PopularExplore";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { observer } from "mobx-react";
import { settingsStore } from "settings/_stores/settingsStore";
import { ISettingsMdl } from "settings/_models/SettingsMdl";

const SOCIALS: { key: keyof ISettingsMdl["links"]; label: string; fallback: string }[] = [
    { key: "fb", label: "Facebook", fallback: "https://www.facebook.com/vistoo" },
    { key: "ig", label: "Instagram", fallback: "https://www.instagram.com/vistoo" },
    { key: "li", label: "LinkedIn", fallback: "https://www.linkedin.com/company/vistoo" },
];

// Valeurs de repli quand les settings ne sont pas chargés (ex. page d'accueil) :
// les coordonnées et réseaux doivent toujours apparaître dans le footer.
const DEFAULT_EMAIL = "info@vistoo.com";

export const Footer = observer(function Footer() {
    const { t } = useTranslation();
    const settings = settingsStore.getOne();
    const contacts = settings?.contacts;
    const links = settings?.links;
    const year = new Date().getFullYear();

    return (
        <>
            <PopularExplore />
            <footer className={styles.container}>
                <div className={styles.inner}>
                    <div className={styles.top}>
                        <div className={styles.brand}>
                            <Logo containerClassName={styles.logo} width={150} height={50} />
                            <div className={styles.contact}>
                                <a href={`mailto:${contacts?.emailContact || DEFAULT_EMAIL}`} className={styles.email}>
                                    {contacts?.emailContact || DEFAULT_EMAIL}
                                </a>
                                <div className={styles.address}>{t("footer.tagline")}</div>
                            </div>
                        </div>

                        <div className={styles.colNav}>
                            <FooterLinkList titleLabel={t("footer.officialLinks")} list={LINKS(i18next.language)} />
                        </div>

                        <div className={styles.colSubscribe}>
                            <FooterSubscribe />
                        </div>
                    </div>

                    <div className={styles.bottom}>
                        <div className={styles.copyright}>
                            © {year} Vistoo Inc. · {t("footer.copyright")}
                        </div>
                        <div className={styles.socials}>
                            {SOCIALS.map((social) => {
                                const url = links?.[social.key] || social.fallback;
                                return (
                                    <a
                                        key={social.key}
                                        href={url}
                                        target={"_blank"}
                                        rel={"noopener noreferrer"}
                                        className={styles.socialLink}
                                    >
                                        {social.label.toUpperCase()}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
});
